export type Change = {
    delta: number
    percent: number | null // null if there is nothing to relate the change to
};

/**
 * The change of an amount against the amount before. The percentage is only given if the amount
 * before was positive: relative to zero or to a negative amount, such as a month of credit notes,
 * it would say nothing.
 */
export function changeBetween(current: number, previous: number): Change {
    return {
        delta: current - previous,
        percent: previous <= 0 ? null : (current - previous) / Math.abs(previous),
    };
}
